(() => {
  const STAGES = [
    ['ordered', 'Order placed'],
    ['shipped', 'Shipped'],
    ['in_transit', 'In transit'],
    ['delivered', 'Delivered'],
  ];
  const STATUS_LABEL = {
    ordered: 'Being made',
    shipped: 'Shipped',
    in_transit: 'In transit',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
  };

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const fmtDate = (iso) =>
    iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
  const humanize = (s) => String(s || '').toLowerCase().replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
  const trackUrl = (t) => t.url || 'https://t.17track.net/en#nums=' + encodeURIComponent(t.number || '');

  function renderOrder(box, order, support) {
    box.replaceChildren();

    const head = el('div', 'lt-result__head');
    const title = el('div');
    title.append(el('h2', null, 'Order ' + order.name), el('p', null, 'Placed ' + fmtDate(order.createdAt)));
    head.append(title, el('span', 'lt-pill lt-pill--' + order.stage, STATUS_LABEL[order.stage] || humanize(order.stage)));
    box.append(head);

    if (order.cancelled) {
      box.append(el('p', 'lt-note lt-note--warn', 'This order was cancelled. If you have questions, contact ' + support + '.'));
    } else {
      const reached = STAGES.findIndex(([key]) => key === order.stage);
      const bar = el('ol', 'lt-bar');
      STAGES.forEach(([, label], i) => {
        const li = el('li', i <= reached ? 'is-done' : '');
        if (i === reached) li.classList.add('is-current');
        li.append(el('span', 'lt-bar__dot'), el('span', 'lt-bar__label', label));
        bar.append(li);
      });
      box.append(bar);

      if (!order.shipments.length) {
        box.append(
          el(
            'p',
            'lt-note',
            "We're making your personalized order (3–5 business days). You'll get an email with your tracking number as soon as it ships."
          )
        );
      }
    }

    order.shipments.forEach((s, i) => {
      const card = el('div', 'lt-ship');
      const top = el('div', 'lt-ship__top');
      top.append(
        el('strong', null, order.shipments.length > 1 ? 'Package ' + (i + 1) : 'Your package'),
        el('span', 'lt-ship__status', humanize(s.status))
      );
      card.append(top);
      const meta = [];
      if (s.shippedAt) meta.push('Shipped ' + fmtDate(s.shippedAt));
      if (s.deliveredAt) meta.push('Delivered ' + fmtDate(s.deliveredAt));
      else if (s.estimatedDeliveryAt) meta.push('Estimated delivery ' + fmtDate(s.estimatedDeliveryAt));
      if (meta.length) card.append(el('p', 'lt-ship__meta', meta.join(' · ')));
      s.tracking
        .filter((t) => t.number || t.url)
        .forEach((t) => {
          const row = el('div', 'lt-trk');
          const info = el('span');
          info.append(el('small', null, t.company || 'Tracking number'), el('b', null, t.number || ''));
          const a = el('a', 'm-button m-button--primary lt-btn', 'Track package');
          a.href = trackUrl(t);
          a.target = '_blank';
          a.rel = 'noopener';
          row.append(info, a);
          card.append(row);
        });
      box.append(card);
    });

    if (order.items.length) {
      const list = el('ul', 'lt-items');
      order.items.forEach((it) => {
        const li = el('li');
        if (it.image) {
          const img = el('img');
          img.src = it.image;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 64;
          img.height = 64;
          li.append(img);
        } else {
          li.append(el('span', 'lt-items__noimg'));
        }
        const txt = el('span');
        txt.append(el('b', null, it.title));
        if (it.variant) txt.append(el('small', null, it.variant));
        li.append(txt, el('span', 'lt-items__qty', '× ' + it.quantity));
        list.append(li);
      });
      box.append(el('h3', 'lt-items__title', 'Items in this order'), list);
    }

    if (order.statusPageUrl) {
      const a = el('a', 'm-button m-button--secondary lt-btn lt-full', 'View full order details');
      a.href = order.statusPageUrl;
      a.target = '_blank';
      a.rel = 'noopener';
      box.append(a);
    }

    box.hidden = false;
    box.focus({ preventScroll: true });
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.querySelectorAll('[data-lt-lookup]').forEach((form) => {
    const root = form.closest('.luth-track');
    const msg = root.querySelector('[data-lt-msg]');
    const box = root.querySelector('[data-lt-result]');
    const btn = form.querySelector('button[type="submit"]');
    const api = (form.dataset.api || '').replace(/\/$/, '');
    const support = form.dataset.support || 'our support team';

    const showMsg = (text) => {
      msg.textContent = text;
      msg.hidden = !text;
    };

    const params = new URLSearchParams(location.search);
    if (params.get('order')) form.elements.order.value = params.get('order');
    if (params.get('email')) form.elements.email.value = params.get('email');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const order = form.elements.order.value.trim();
      const email = form.elements.email.value.trim();
      if (!order || !email) {
        showMsg('Please enter both your order number and email.');
        return;
      }
      showMsg('');
      btn.disabled = true;
      btn.classList.add('is-loading');
      try {
        const res = await fetch(api + '/api/track', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ order, email }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) {
          showMsg(data.error || 'Something went wrong. Please try again.');
          box.hidden = true;
          return;
        }
        renderOrder(box, data.order, support);
      } catch (_) {
        showMsg('We could not reach our order system. Please try again, or sign in to your account to see your orders.');
      } finally {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    });
  });

  document.querySelectorAll('[data-lt-number]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const nums = form.elements.nums.value.replace(/\s+/g, '');
      if (!nums) return;
      e.preventDefault();
      window.open('https://t.17track.net/en#nums=' + encodeURIComponent(nums), '_blank', 'noopener');
    });
  });
})();
